import { jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { FileOutlined as C } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/file-outlined.es.es.js";
import { PDFFileOutlined as o } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/pdf-file-outlined.es.es.js";
import { VideoPlayOutlined as t } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/video-play-outlined.es.es.js";
import { ZipOutlined as n } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/zip-outlined.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { Primary } from "../../../foundations/palette.es.js";
function FilePreview({
  fileType,
  fileUrl,
  fileName
}) {
  if (fileType.includes("image") && fileUrl) {
    return /* @__PURE__ */ jsx("img", { src: fileUrl, alt: `file preview ${fileName}`, style: {
      maxWidth: Spacing["12500"],
      maxHeight: Spacing["12500"]
    }, "data-testid": "file-image-preview" });
  }
  if (fileType.includes("pdf")) {
    return /* @__PURE__ */ jsx(o, { color: "primary", style: {
      width: Spacing["2180"],
      height: Spacing["2180"]
    }, "data-testid": "pdf-file-outlined-icon" });
  }
  if (fileType.includes("zip")) {
    return (
      //@ts-ignore
      /* @__PURE__ */ jsx(n, { style: {
        fontSize: Spacing["2180"]
      }, color: Primary.main, "data-testid": "zip-file-outlined-icon" })
    );
  }
  if (fileType.includes("video")) {
    return /* @__PURE__ */ jsx(t, { color: "primary", style: {
      width: Spacing["2180"],
      height: Spacing["2180"]
    }, "data-testid": "video-play-outlined-icon" });
  }
  return /* @__PURE__ */ jsx(C, { color: "primary", style: {
    width: Spacing["2180"],
    height: Spacing["2180"]
  }, "data-testid": "file-outlined-icon" });
}
export {
  FilePreview
};
//# sourceMappingURL=file-icon.es.js.map
